import { Box } from "@mui/material";
import { ReactNode } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { Text } from "$components";
import JOrderTree from "../JOrderTree/JOrderTree";
import { edbIoToOrders } from "$containers/EDB/IntegratedOrdersPopin/utils";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import { theme } from "$utils/theme/bataillog";

type Props = {
  emptyMessage?: string;
  hasInitialIntegratedOrders?: boolean;
  header?: ReactNode;
  hideProductsWithQtyZero?: boolean;
  integratedOrders: EDBIntegratedOrders;
  noInitialIntegratedOrdersMessage?: string;
  title?: string;
};

export enum MESSAGES {
  ALL_PRODUCTS_TREATED = "Tous les produits ont été traités.",
  EMPTY_INTEGRATED_ORDERS = "Vous êtes sur le point de vider toutes les commandes intégrées. Souhaitez-vous continuer ?",
  NO_INTEGRATED_PRODUCTS = "Aucun produit n'a été intégré à l'EDB.",
  NO_ORDERS_FOUND = "Aucune commande correspondant à vos critères de recherche n'a été trouvée. Essayez de supprimer certains critères ci-dessus.",
}

function IntegratedOrders({
  emptyMessage = MESSAGES.EMPTY_INTEGRATED_ORDERS,
  hasInitialIntegratedOrders = true,
  header,
  hideProductsWithQtyZero = false,
  integratedOrders,
  noInitialIntegratedOrdersMessage = "Aucun produit intégré",
  title = "Commande(s) intégrée(s)",
}: Props) {
  const classes = useStyles();

  const isACommandIntegrated =
    integratedOrders?.orderProducts?.length > 0 &&
    integratedOrders?.orderProducts?.some((p) => p.quantity > 0);

  return (
    <Box>
      <Box className={classes.header}>
        <Text type="h3" className={classes.subtitle}>
          {title}
        </Text>
      </Box>

      {isACommandIntegrated ? (
        <>
          {header}
          <JOrderTree
            expandAllNodes
            hideProductsWithQtyZero={hideProductsWithQtyZero}
            orders={edbIoToOrders(integratedOrders)}
          />
        </>
      ) : hasInitialIntegratedOrders ? (
        <Text>{emptyMessage}</Text>
      ) : (
        <Text>{noInitialIntegratedOrdersMessage}</Text>
      )}
    </Box>
  );
}

export default IntegratedOrders;

const useStyles = createUseStyles(() => ({
  buttons: {
    flex: 1,
    justifyContent: "flex-end",
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
  },
  header: {
    alignItems: "center",
    display: "flex",
  },
  subtitle: {
    fontWeight: "bold",
  },
}));
